import multiEditSlice from './slice';

export default multiEditSlice.reducer;
